import React, { useState } from "react";
import "../TemplateDriven/dataMapTable.scss";
import { TextField } from "@mui/material";
import { isDisable } from "../TemplateDriven/EditableCellConfig";

const ProcessorValueEditableCell = ({
  textValue,
  parameterIndex,
  handleBlurValue,
  onClickCellToRedirect,
  parametersData,
  mapping,
  mappingIndex,
  rowRejectionData,
  role = "processor",
  entireBatchRejectedByVali,
  reProcess,
  isDataRejectedByValidator,
  reProcessEntireBatch,
}) => {
  const [value, setValue] = useState(textValue);

  React.useEffect(() => {
    if (textValue !== value) {
      setValue(textValue);
    }
  }, [textValue]);

  const handleChangeValue = (changedValue) => {
    setValue(changedValue);
  };

  const styleRejectedCell = (
    mapping,
    mappingIndex,
    rowRejectionData,
    parameterIndex
  ) => {
    let backgroundColor = "#FFFF";

    if (role === "processor") {
      // for resolved and Pro want to see comment'
      if (
        mapping?.processorCellRejection?.isResolved ||
        parametersData[parameterIndex]?.processorRowRejection?.isResolved
      ) {
        backgroundColor = "#CCE5FF";
      }
      if (
        mapping?.processorCellRejection?.isResolved &&
        parametersData[parameterIndex]?.processorRowRejection?.isResolved
      ) {
        backgroundColor = "#CCE5FF";
      }

      // any one rejected in cell or row in both role
      if (
        mapping?.processorCellRejection?.isRejected ||
        mapping?.validatorCellRejection?.isRejected ||
        parametersData[parameterIndex]?.processorRowRejection?.isRejected ||
        parametersData[parameterIndex]?.validatorRowRejection?.isRejected
      ) {
        backgroundColor = "rgb(255 137 116)";
      }

      // dark red color in cell for both role cell rejection only
      if (
        mapping?.processorCellRejection?.isRejected &&
        mapping?.validatorCellRejection?.isRejected
      ) {
        backgroundColor = "rgb(253 97 71)";
      }

      // dark red when cell and row rej by processor
      if (
        mapping?.processorCellRejection?.isRejected &&
        parametersData[parameterIndex]?.processorRowRejection?.isRejected
      ) {
        backgroundColor = "rgb(253 97 71)";
      }

      // dark red color for both role rejection in row
      if (
        parametersData[parameterIndex]?.processorRowRejection?.isRejected &&
        parametersData[parameterIndex]?.validatorRowRejection?.isRejected
      ) {
        backgroundColor = "rgb(253 97 71)";
      }

      // dark red if row rejected by vali and cell rej by pro
      if (
        parametersData[parameterIndex]?.validatorRowRejection?.isRejected &&
        // valiRowRejectionDataInPro[mappingIndex]?.isRowRejectedByValidator &&
        mapping?.processorCellRejection?.isRejected
      ) {
        backgroundColor = "rgb(253 97 71)";
      }

      // dark red if cell rejected by vali and row rej by pro
      if (
        mapping?.validatorCellRejection?.isRejected &&
        parametersData[parameterIndex]?.processorRowRejection?.isRejected
      ) {
        backgroundColor = "rgb(253 97 71)";
      }

      // dark red if cell rejected by vali and also row rej by vali
      if (
        mapping?.validatorCellRejection?.isRejected &&
        parametersData[parameterIndex]?.validatorRowRejection?.isRejected
      ) {
        backgroundColor = "rgb(253 97 71)";
      }
      // if cell is rej by vali and also row rejected and also cell rej by pro
      if (
        mapping?.validatorCellRejection?.isRejected &&
        parametersData[parameterIndex]?.validatorRowRejection?.isRejected &&
        mapping?.processorCellRejection?.isRejected
      ) {
        backgroundColor = "rgb(249 61 61)";
      }
      //  if cell is rej by vali and also row rejected and also row rej by pro
      if (
        mapping?.validatorCellRejection?.isRejected &&
        parametersData[parameterIndex]?.validatorRowRejection?.isRejected &&
        parametersData[parameterIndex]?.processorRowRejection?.isRejected
      ) {
        backgroundColor = "rgb(253 32 32)";
      }
      if (
        mapping?.processorCellRejection?.isRejected &&
        mapping?.validatorCellRejection?.isRejected &&
        parametersData[parameterIndex]?.validatorRowRejection?.isRejected &&
        parametersData[parameterIndex]?.processorRowRejection?.isRejected
      ) {
        backgroundColor = "rgb(235 44 109)";
      }
    }

    return { backgroundColor };
  };

  const isDisableWrapper = (mapping, mappingIndex, parameterIndex) => {
    if (mapping?.isDerivativeField) {
      return true;
    }
    const isDisableFlag = isDisable(
      mapping,
      mappingIndex,
      parameterIndex,
      role,
      "NA", //isDataRejectedByProcessor
      "NA", //entireBatchRejectedByPro
      parametersData,
      entireBatchRejectedByVali,
      reProcessEntireBatch,
      reProcess,
      isDataRejectedByValidator,
      "NA" //reValidate
    );
    return isDisableFlag;
  };

  const disableText = isDisable(
    mapping,
    mappingIndex,
    parameterIndex,
    role,
    "NA", //isDataRejectedByProcessor
    "NA", //entireBatchRejectedByPro
    parametersData,
    entireBatchRejectedByVali,
    reProcessEntireBatch,
    reProcess,
    isDataRejectedByValidator,
    "NA" //reValidate
  )
    ? true
    : false;

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div
        style={{
          ...styleRejectedCell(
            mapping,
            mappingIndex,
            rowRejectionData,
            parameterIndex
          ),
          ...{
            padding: "0px 15px 0px 5px",
          },
          // to heighlight selected  cell for re initiate vlm

          ...(mapping?.reInitiateProVlm && {
            border: "2px solid #2776d2", // Example for "selected for reprocess"
          }),
          height: "100%",
          width: "100%",
        }}
      >
        <TextField
          className={` ${"my-textarea"} ${disableText ? "disableCell" : ""}`}
          multiline
          value={value}
          onChange={(e) => handleChangeValue(e.target.value)}
          onBlur={(e) =>
            // parameterData?.mappings[0]?.value !== e.target.value &&
            handleBlurValue(parameterIndex, e.target.value)
          }
          onClick={() => onClickCellToRedirect()}
          variant="outlined"
          size="small"
          fullWidth
          InputProps={{
            style: {
              padding: "0px", // Removes inner padding
            },
          }}
          sx={{
            "& .MuiInputBase-root": {
              padding: "0px", // Ensures no extra padding in the field
            },
            "& .MuiOutlinedInput-input": {
              padding: "4px", // Adjust text padding as needed
            },
          }}
          disabled={isDisableWrapper(mapping, mappingIndex, parameterIndex)}
        />
      </div>
    </div>
  );
};

export default ProcessorValueEditableCell;
